import './assets/main.css'

import '@/fonts/fonts.scss'
import '@/styles/main.scss'
import { ElLoading } from 'element-plus'
import 'utils/src/extensions'
import 'virtual:svg-icons-register'
import { createApp } from 'vue'
import { Geetest } from 'vue3-geetest'
import App from './App'
import router from './router'

import '@/styles/element-plus/dark.scss'
import { i18n } from 'i18n-utils'
import 'requestidlecallback-polyfill'
import { pinia } from 'store'
import { UiUtils, vSafeHtml } from 'ui-components'
import 'vant/lib/index.css'
import '../../../tailwind/tailwind.css'
import { getUserCenterPageRoute, PageRoutes, UserCenterRoutes } from './constants/PageRoutes'
const app = createApp(App)

UiUtils.useRouter(router)
UiUtils.registerLoginRouter(() => {
  router.push(PageRoutes.Login)
})
UiUtils.registerRechargeRouter(() => {
  router.push(getUserCenterPageRoute(UserCenterRoutes.Recharge))
})
UiUtils.registerSecuritySettingsRouter(() => {
  router.push(getUserCenterPageRoute(UserCenterRoutes.SecuritySettings))
})
app.directive('safe-html', vSafeHtml)
app.use(Geetest, {})
app.use(i18n)
app.use(UiUtils)

app.use(pinia)
app.use(ElLoading)
app.use(router)

app.mount('#app')

app.config.performance = true

export const globalApp = app
